import React from "react";

import { observer } from "mobx-react";
import PropTypes from "prop-types";

import CategoryCardVacancyHead from "./CategoryCardVacancyHead";
import DefaultVacancyHead from "./DefaultVacancyHead";
import DescriptiveVacancyHead from "./DescriptiveVacancyHead";
import VacancyWithIconsHead from "./VacancyWithIconsHead";

function VacancyHead(props) {
  const { type } = props;

  let VacancyHeadComponent;

  switch (type) {
    case "descriptive": {
      VacancyHeadComponent = DescriptiveVacancyHead;
      break;
    }
    case "categoryCard": {
      VacancyHeadComponent = CategoryCardVacancyHead;
      break;
    }
    case "withIcons": {
      VacancyHeadComponent = VacancyWithIconsHead;
      break;
    }
    default: {
      VacancyHeadComponent = DefaultVacancyHead;
      break;
    }
  }

  return <VacancyHeadComponent {...props} />;
}

export default observer(VacancyHead);

VacancyHead.propTypes = {
  type: PropTypes.string,
};

VacancyHead.defaultProps = {
  type: "",
};
